'use client';

import { cn } from '@/utils/tailwind-merge';
import { Download } from 'lucide-react';
import { useTranslations } from 'next-intl';

export default function DownloadButton({
    onClick,
    name,
    className = '',
}: {
    onClick?: () => void;
    name?: string;
    className?: string;
}) {
    const t = useTranslations('Common');
    return (
        <button
            className={cn(
                'max-w-[100px] min-w-[100px] w-full text-primary text-md lg:text-h6 uppercase flex justify-end items-center gap-2',
                className,
            )}
            onClick={onClick}
        >
            {t('download')}
            <Download className="min-w-6 min-h-6 max-xl:mr-4" />
        </button>
    );
}
